import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCustomerById } from '../config/customers';
import { getSelectedCustomerId } from '../lib/selectedCustomer';
import { redirectTo, resolveCustomerAppUrl } from '../lib/runtimeUrls';

const PortalRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const selectedCustomerId = getSelectedCustomerId();
    const customer = getCustomerById(selectedCustomerId);

    if (customer) {
      redirectTo(resolveCustomerAppUrl(customer));
      return;
    }

    navigate('/velg-kommune', { replace: true });
  }, [navigate]);

  return null;
};

export default PortalRedirect;
